module.exports = __webpack_public_path__ + "static/media/ic_document_cash.aa01abc3.svg";